import { Delete, Edit } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    Box,
    Breadcrumbs,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    Menu,
    MenuItem,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import React, { Fragment, Suspense, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { deleteFinalizedInvoice, sendInvoice, updateInvoiceRecordPayments } from '../../../redux/Invoice/action';
import {
    INVENTORY_MANAGE_TYPE,
    INVENTORY_TYPES,
    MILEAGE_UNIT,
    normalizeWorkOrderStatus,
    PART_TYPES,
    PRICING_TYPES,
    USER_TIMEZONE,
    WORK_ORDER_STATUS,
} from '../../../utility/Constant';
import SuccessMessageModal from '../../Common/SuccessMessage';
import AddInventoryModal from '../../Inventory/AddInventory';

import { useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import CommonDialog from '../../../common/CommonDialog';
import { APPOINTMENT_STATUS, SHOP_CREATED, USER_TYPES } from '../../../config/dataService/constants';
import { discountProgramApi } from '../../../redux/Account/Pricing/action';
import { appointmentKeys, useAppointmentDetails } from '../../../services/business/appointment';
import { businessInvoicesKeys } from '../../../services/business/invoices/invoices.hooks';
import { reviewRequestKeys } from '../../../services/business/reviewRequest/reviewRequest.hooks.js';
import { useGetShopConfig, useGetShopTaxes } from '../../../services/core/settings';
import { filterUndefined, truncateToFixed } from '../../../utility/helpers/commonFunction';
import { shouldShowPerServiceSubtotalRow } from '../../../utility/helpers/shouldShowPerServiceSubtotalRow';
import { DISCOUNT_SOURCE, hydrateDiscountFromResponse } from '../../../utility/helpers/discountCalculation';
import { NumericEngine } from '../../../utility/helpers/numericEngine';
import {
    calculateDocumentTotals,
    DOCUMENT_TAX_TYPE,
    getShopTaxRules,
    isNewTaxVersion,
    LINE_TAX_KIND,
    mergeShopTaxRulesIntoBreakdown,
    shouldSyncCalculatedBreakdown,
    recordHasPartsOrPackages,
    recordPartGrossAmount,
} from '../../../utility/helpers/taxCalculation';
import { useProvinceTaxGroup } from '../../../utility/hooks/useProvinceTaxGroup';
import LineTaxCell from '../../../common/Tax/LineTaxCell';
import LinkedDocumentLink, { getEstimateDetailUrl } from '../../../common/LinkedDocumentLink';
import LinkIcon from '../../../utility/Svg/LinkIcon';
import PartBrandSvg from '../../../utility/Svg/PartBrandSvg';
import PartCategorySvg from '../../../utility/Svg/PartCategorySvg';
import SaveAndSendSvg from '../../../utility/Svg/SaveAndSendSvg';
import AppointmentModel from '../../Appointment/AppointmentModel';
import UpdateCustomerModal from '../../Customers/Profile/UpdateCustomerModal';
import BatchViewModal from '../../Inventory/BatchViewModal';
import RecordPaymentDialog from '../GenrateInvoice/RecordPayementDialog';
import InvoiceFeesTable from '../invoiceCommonComponents/InvoiceFeesTable';
import DetailPageHeaderInfoColumns from '../invoiceCommonComponents/DetailPageHeaderInfoColumns';
import InvoicePaymenetDetails from '../invoiceCommonComponents/InvoicePaymenetDetails';
import InvoiceRecommandationSection from '../invoiceCommonComponents/InvoiceRecommandationSection.jsx';
import InvoiceStatusChips from '../invoiceCommonComponents/InvoiceStatusChips';
import InvoiceTermsWarranty from '../invoiceCommonComponents/InvoiceTermsWarranty';
import ShopSuppliesTable from '../invoiceCommonComponents/ShopSuppliesTable';
import AddCustomerModalV4 from '../../../common/AddCustomerModalV4/index.jsx';
import { downloadPdfFromUrl, openPdfUrl } from '../../../utility/helpers/fileDownload';

const InvoiceFinalized = ({ invoiceId, invoiceData = {}, setCustomerData, setShowLoader, fetchApi, showLoader }) => {
    const provinceTaxGroup = useProvinceTaxGroup();
    const documentHasPartsOrPackages = recordHasPartsOrPackages(invoiceData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState('');

    const [selectedInventoryId, setSelectedInventoryId] = useState(null);
    const [batchNumber, setBatchNumber] = useState(null);
    const [openPartModel, setOpenpartModel] = useState(false);

    const [serviceListPayload, setServiceListPayload] = useState([]);
    const [discountId, setDiscountId] = useState(null);
    const [selectedDiscount, setSelectedDiscount] = useState(null);

    const [openBatchSelectionModal, setBatchSelectionModal] = useState(false);
    const [inventoryOption, setInventoryOption] = useState(null);

    const [openEditCustomer, setOpenEditCustomer] = useState(false);

    const [isFinalizedEmail, setIsFinalizedEmail] = useState(false);
    const [customerMembershipId, setCustomermemberShipId] = useState(null);
    const [primaryEmailIndex, setPrimaryEmailIndex] = useState(0);
    const [addressValues, setAddressValue] = useState({
        street_number: '',
        city: '',
        province: '',
        postal: '',
        country: '',
        provinceId: '',
        cityId: '',
    });

    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [selectedFees, setSelectedFees] = useState([]);
    const [isRecordModal, setIsRecordModal] = useState(false);
    const isSendEmailRef = useRef(false);
    const newMethod = { transactionType: 'payment', paymentMethod: 'credit', amount: '', paymentReference: '', paymentDate: null };

    const [paymentMethods, setPaymentMethods] = useState([]);
    const [paymentDetails, setPaymentDetails] = useState({
        discount: 0,
        discountPercentage: 0,
        discountSource: DISCOUNT_SOURCE.PERCENTAGE,
        tax: 0,
        taxPercentage: 13,
        fees: 0,
        subTotal: 0,
        labourTotal: 0,
        partsTotal: 0,
        total: 0,
    });
    const [taxesBreakdown, setTaxesBreakdown] = useState([]);
    const [isNewTaxVersionActive, setIsNewTaxVersionActive] = useState(false);

    const { data: shopTaxesData } = useGetShopTaxes();

    const showLineTax = isNewTaxVersion(invoiceData);

    //google review flow hooks (single source for Carfax + Google Review + custom message)
    const [googleReviewDetails, setGoogleReviewDetails] = useState({
        shouldSendInvoiceToCarfax: false,
        sendGoogleReviewRequest: false,
        customMessage: '',
        shouldSendReviewSMSToCustomer: false,
        shouldSendReviewEmailToCustomer: false,
        shouldSendReviewNotificationToCustomer: false,
    });
    const [appointmentData, setAppointmentData] = useState(null);
    const [googleReviewMessage, setGoogleReviewMessage] = useState('');
    const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);
    const [appointmentIdForModal, setAppointmentIdForModal] = useState(null);

    const { data: appointmentDetailData, isLoading: isDetailLoading } = useAppointmentDetails(appointmentIdForModal, {
        enabled: !!appointmentIdForModal,
    });

    const appointmentModalColumns = useMemo(() => {
        const d = appointmentDetailData?.data;
        if (!d?.status) return {};
        return { [d.status]: { name: d.status, items: [d] } };
    }, [appointmentDetailData?.data]);

    const handleCloseAppointmentModal = () => {
        setAppointmentModalOpen(false);
        setAppointmentIdForModal(null);
        handleClose1();
        fetchApi();
    };

    const refreshAppointmentDetails = () => {
        if (appointmentIdForModal) {
            queryClient.invalidateQueries({ queryKey: appointmentKeys.details(appointmentIdForModal) });
        }
    };

    const SHOP_NAME = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('apex-saas_details'))?.shopName || '';
        } catch (e) {
            return '';
        }
    }, []);

    const { data: shopConfigData, isLoading: isConfigLoading, error: configError } = useGetShopConfig();

    const mileageUnit = shopConfigData?.config?.mileageUnit === MILEAGE_UNIT.MILES ? MILEAGE_UNIT.MILES : MILEAGE_UNIT.KM;

    const {
        handleSubmit,
        control,
        formState: { errors },
        trigger,
        setValue,
        getValues,
        reset,
        setFocus,
        clearErrors,
        resetField,
    } = useForm();

    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const open1 = Boolean(anchorEl);
    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const handlePrintPdf = () => {
        openPdfUrl(invoiceData?.pdfUrl);
        handleClose1();
    };

    const clickDownload = async () => {
        await downloadPdfFromUrl(invoiceData?.pdfUrl, `${invoiceData?.invoiceNumber || 'invoice'}.pdf`);
    };

    const hasCustomerEmail = !!invoiceData?.customer?.email;
    const customerId = invoiceData?.customer?._id;

    const handleSend = async () => {
        try {
            setShowLoader(true);
            const data = await dispatch(sendInvoice(invoiceId));
            if (data) {
                toast.success('Invoice was successfully emailed to customer');

                handleClose1();
                setTimeout(() => {
                    fetchApi();
                    navigate(`/invoice/sent/${invoiceId}`);
                }, 1500);
            } else {
                // the reason was already shown by the response interceptor
                setShowLoader(false);
            }
        } catch (error) {
            setShowLoader(false);
        }
    };

    useEffect(() => {
        (async () => {
            const membershipResp = await dispatch(discountProgramApi());
            const resp = invoiceData;
            console.log('🚀 ~ InvoiceFinalized ~ resp:', resp);
            if (!resp) return;

            setValue('isDraft', false);
            setValue('customerId', resp.customer?._id);
            setValue('vehicleId', resp.vehicle?._id);

            let isFinalized = false;
            if (resp.status === 'sent' && !resp.isEmailSent) {
                setIsFinalizedEmail(true);
                isFinalized = true;
            }

            const rr = resp?.reviewRequest;
            const cfg = shopConfigData?.config;

            setGoogleReviewDetails({
                shouldSendInvoiceToCarfax: resp?.shouldSendInvoiceToCarfax ?? false,
                sendGoogleReviewRequest: rr?.reviewCompleted ?? false,
                customMessage: rr?.customMessage ?? '',
                shouldSendReviewSMSToCustomer: rr?.shouldSendReviewSMSToCustomer ?? cfg?.shouldSendReviewSMSToCustomer ?? false,
                shouldSendReviewEmailToCustomer: rr?.shouldSendReviewEmailToCustomer ?? cfg?.shouldSendReviewEmailToCustomer ?? false,
                shouldSendReviewNotificationToCustomer: rr?.shouldSendReviewNotificationToCustomer ?? cfg?.shouldSendReviewNotificationToCustomer ?? false,
            });

            // Set appointmentData from invoice's linked appointment (when editing invoice created from appointment)
            if (resp?.appointment?._id) {
                const appt = resp.appointment;
                const fullname = appt.customer?.fullName || [appt.customer?.firstName, appt.customer?.lastName].filter(Boolean).join(' ').trim() || '—';
                const v = appt.vehicle;
                const vehicleStr =
                    [v?.vehicleYear || v?.year, v?.vehicleMake?.name, v?.vehicleModel?.name, v?.vehicleModelTrim?.name].filter(Boolean).join(' ') || '—';
                const dropOff = appt.dropOffDateTime ? dayjs(appt.dropOffDateTime).tz(USER_TIMEZONE) : null;
                const dateTimeStr = dropOff ? dropOff.format('DD-MMM-YYYY - hh:mm A') : '—';
                const servicesCount = appt?.services?.length ? `${appt.services.length} Service${appt.services.length !== 1 ? 's' : ''}` : '0 Services';
                setAppointmentData({
                    _id: appt._id,
                    status: appt.status,
                    customerName: fullname,
                    appointmentId: appt.appointmentNumber || appt._id?.slice(-6) || '—',
                    vehicle: vehicleStr,
                    dateTime: dateTimeStr,
                    servicesCount,
                });
            } else {
                setAppointmentData(null);
            }

            const allReviewGroups = Array.isArray(resp?.googleReviewRequest) ? resp.googleReviewRequest : [];
            const firstReviewGroup = allReviewGroups.length > 0 ? allReviewGroups[0] : null;
            const reviewRequests = Array.isArray(firstReviewGroup?.reviewRequest) ? firstReviewGroup.reviewRequest : [];
            const lastRequest = reviewRequests.length > 0 ? reviewRequests[reviewRequests.length - 1] : null;
            const lastSentAt = firstReviewGroup?.lastSentAt;
            const isWithin24Hours = lastSentAt && dayjs(lastSentAt).tz(USER_TIMEZONE).isAfter(dayjs().tz(USER_TIMEZONE).subtract(24, 'hours'));

            if (!firstReviewGroup || !lastSentAt) {
                setGoogleReviewMessage('');
            } else {
                const channels = [];
                if (lastRequest?.sms?.sent) channels.push('text');
                if (lastRequest?.email?.sent) channels.push('email');
                if (lastRequest?.notification?.sent) channels.push('app');

                let channelsLabel = '—';
                if (channels.length === 1) channelsLabel = channels[0];
                else if (channels.length === 2) channelsLabel = `${channels[0]} and ${channels[1]}`;
                else if (channels.length >= 3) channelsLabel = `${channels[0]}, ${channels[1]} and ${channels[2]}`;

                const formattedDate = dayjs(lastSentAt).tz(USER_TIMEZONE).format('DD-MMMM-YYYY');
                const totalRequests = allReviewGroups.length;

                if (isWithin24Hours) {
                    setGoogleReviewMessage(`Last sent via ${channelsLabel} today`);
                } else if (totalRequests === 1) {
                    setGoogleReviewMessage(`Last sent via ${channelsLabel} on ${formattedDate}`);
                } else {
                    setGoogleReviewMessage(`${totalRequests} review requests sent previously. Last sent via ${channelsLabel} on ${formattedDate}`);
                }
            }

            setValue('customerPO', resp.customerPO || undefined);
            setValue('note', resp.note || '');
            setValue('termsAndWarranty', resp.termsAndWarranty || undefined);
            // setValue('invoicePreparedBy', resp.invoicePreparedBy || undefined);
            setValue('serviceAdvisor', resp.serviceAdvisor?._id || resp.serviceAdvisor || undefined);
            setValue('serviceTechnician', resp.serviceTechnician?._id || resp.serviceTechnician || undefined);
            setValue('odoDroppedOff', resp.odoDroppedOff || '');
            setValue('odoReturned', resp.odoReturned || '');
            setValue('appointmentDroppedOffDate', resp.appointmentDroppedOffDate || '');
            setValue('appointmentCompletionDate', resp.appointmentCompletionDate || '');
            setValue('invoiceDate', resp.invoiceDate || '');

            const hydratedDiscount = hydrateDiscountFromResponse({
                subTotal: resp?.subTotal || 0,
                discount: resp.discount || 0,
                discountPercentage: resp.discountPercentage,
                discountSource: resp.discountSource,
                membershipProgramId: resp.membershipProgram?._id,
                programPercentage: resp.membershipProgram?.discount,
            });
            setPaymentDetails((prev) => ({
                ...prev,
                total: NumericEngine.format(resp?.Total || 0),
                taxPercentage: resp.taxPercentage || 0,
                discount: Number(hydratedDiscount.discountValue),
                discountPercentage: hydratedDiscount.discountPercentage.toString(),
                discountSource: hydratedDiscount.discountSource,
            }));

            if (isNewTaxVersion(resp)) {
                setIsNewTaxVersionActive(true);
                setTaxesBreakdown(resp.taxesBreakdown || []);
            } else {
                setIsNewTaxVersionActive(false);
                setTaxesBreakdown([]);
            }

            const services = [];
            const serviceInd = [];
            const batchQtyMap = {};
            const finalizedInventory = {};

            resp.services?.forEach((data, serviceIndex) => {
                serviceInd.push(serviceIndex);
                const serviceObj = { parts: [] };

                if (data.pricingType === PRICING_TYPES.FXIED) {
                    serviceObj.serviceCategory = data.serviceId?.serviceCategory;
                    serviceObj.service = {
                        _id: data.serviceId?._id,
                        name: data.serviceId?.name,
                    };
                    serviceObj.fixedPrice = data.fixedPrice;
                    serviceObj.showDesc = !!data.description;
                    if (data.description) serviceObj.optionalDescription = data.description;
                    serviceObj.pricingType = data.pricingType;
                    serviceObj.type = 'select';
                    // Carry the saved per-line tax so this recompute matches the stored per-line state.
                    serviceObj.taxesBreakdown = data.taxesBreakdown;
                }

                if (data.pricingType === PRICING_TYPES.LABOUR) {
                    if (data.labor?.qty && data.labor?.ratePerHour) {
                        serviceObj.qty = data.labor.qty;
                        serviceObj.ratePerHour = data.labor.ratePerHour;
                        const qty = Number(data?.labor?.qty) || 0;
                        const rate = Number(data?.labor?.ratePerHour) || 0;
                        serviceObj.amount = qty && rate ? Number(NumericEngine.multiply(qty, rate)) : 0;
                    }

                    serviceObj.serviceCategory = data.serviceId?.serviceCategory;
                    serviceObj.service = {
                        _id: data.serviceId?._id,
                        name: data.serviceId?.name,
                    };
                    serviceObj.showDesc = !!data.description;
                    if (data.description) serviceObj.optionalDescription = data.description;

                    serviceObj.pricingType = data.pricingType;
                    serviceObj.type = 'select';
                    serviceObj.taxesBreakdown = data.labor?.taxesBreakdown;

                    data?.parts &&
                        data?.parts?.length > 0 &&
                        data.parts?.forEach((prt, prtIndex) => {
                            if (isFinalized && prt?.inventoryId) {
                                finalizedInventory[prt.inventoryId] = (finalizedInventory[prt.inventoryId] || 0) + prt.totalQty;
                            }

                            let part;
                            const isManaged = prt.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED || !prt.inventoryType;

                            if (isManaged) {
                                part = {
                                    partFromApi: true,
                                    _id: prt.inventoryId || prt.inventory?._id,
                                    partsType: prt.partsType,
                                    part: {
                                        _id: prt.part?._id,
                                        partsType: prt.partsType,
                                        partName: prt.partName,
                                    },
                                    supplier: {
                                        _id: prt.supplier?._id,
                                        name: prt.supplier?.name,
                                    },
                                    partsBrand: {
                                        _id: prt.partsBrand?._id,
                                        name: prt.partsBrand?.name,
                                    },
                                    partsCategory: {
                                        _id: prt.partsCategory?._id,
                                        name: prt.partsCategory?.name,
                                    },
                                    inventoryType: prt.inventoryType || INVENTORY_MANAGE_TYPE.MANAGED,
                                    taxesBreakdown: prt.taxesBreakdown,
                                    fee: prt.fee,
                                    feeAmount: Number(truncateToFixed(prt.feeAmount)),
                                    batchNumber: prt.batchNumber,
                                    partCost: NumericEngine.format(prt?.cost || 0),
                                    partQty: prt.totalQty,
                                    description: prt.lastDescription || prt.description,
                                    partNumber: prt.partNumber,
                                    tyreDimension: prt.tyreDimension,
                                    partsProvider: prt.partsProvider,
                                    retailPrice: Number(prt.cost),
                                    totalAmount: NumericEngine.format(prt?.totalAmount || 0),
                                    batchArray:
                                        prt.inventoryBatches?.map((batch, batchIndex) => {
                                            batchQtyMap[batch.batchNumber] = (batchQtyMap[batch.batchNumber] || 0) + batch.qty;
                                            return {
                                                outerIndex: serviceIndex,
                                                innerIndex: prtIndex,
                                                batchIndex,
                                                batchNumber: batch.batchNumber,
                                                batchQty: batch.qty?.toString(),
                                            };
                                        }) || [],
                                };
                            } else {
                                part = {
                                    inventoryType: INVENTORY_MANAGE_TYPE.UNMANAGED,
                                    partName: prt.partName,
                                    partQty: prt.totalQty,
                                    partCost: NumericEngine.format(prt?.cost || 0),
                                    totalAmount: NumericEngine.format(prt?.totalAmount || 0),
                                    taxesBreakdown: prt.taxesBreakdown,
                                };
                            }

                            serviceObj.parts.push(part);
                        });
                }

                services.push(serviceObj);
            });

            setServiceListPayload(services);

            let feesArray = [];
            if (resp?.fees?.length > 0) {
                resp.fees.map((item, index) => {
                    feesArray.push({
                        isEdit: true,
                        _id: item?.feesId?._id,
                        name: item?.feesId?.name,
                        percentage: item?.feesPercentage,
                        calculationType: item?.feesCalculationType,
                        amount: item?.feesAmount,
                        taxesBreakdown: item?.taxesBreakdown,
                    });
                });
            }

            setSelectedFees(feesArray);

            if (resp.membershipProgram?._id) {
                setDiscountId(resp.membershipProgram._id);
                if (membershipResp.length > 0) {
                    const sd = membershipResp.find((item) => item._id === resp.membershipProgram._id);
                    setSelectedDiscount(sd);
                }
            } else {
                setDiscountId(resp.discount ? 'custom' : 'none');
            }

            const allServices = services.map((d) => {
                const data = {
                    serviceId: d.service?._id,
                    description: d.optionalDescription,
                    pricingType: d.pricingType,
                };

                if (d.pricingType === PRICING_TYPES.FXIED) {
                    data.fixedPrice = Number(d.fixedPrice) || '';
                    if (!d.fixedPrice || Number(d.fixedPrice) <= 0) {
                        toast.error('Please add a price for all services.');
                    }
                }

                if (d.pricingType === PRICING_TYPES.LABOUR) {
                    data.labor = {
                        qty: d.qty,
                        ratePerHour: d.ratePerHour,
                    };

                    data.parts = d.parts
                        ?.map((part) => {
                            if (!part.inventoryType || part.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED) {
                                if (!part._id) return null;
                                const mappedPart = {
                                    inventoryType: INVENTORY_MANAGE_TYPE.MANAGED,
                                    inventoryId: part._id,
                                    totalQty: Number(part.partQty),
                                    retailPrice: Number(part.partCost),
                                };
                                if (Array.isArray(part.batchArray) && part.batchArray.length > 0) {
                                    mappedPart.batches = part.batchArray.map((batch) => ({
                                        batchNumber: batch.batchNumber,
                                        qty: batch.batchQty,
                                    }));
                                }
                                return mappedPart;
                            } else {
                                return {
                                    inventoryType: INVENTORY_MANAGE_TYPE.UNMANAGED,
                                    partName: part.partName,
                                    totalQty: Number(part.partQty),
                                    retailPrice: Number(part.partCost),
                                };
                            }
                        })
                        .filter(Boolean);
                }

                return data;
            });

            setValue('services', allServices);

            if (resp.appointmentId) {
                setValue('appointmentId', resp.appointmentId);
            }

            if (resp.payments?.length > 0) {
                setPaymentMethods(resp.payments);
            }
        })();
    }, [invoiceId, invoiceData, shopConfigData]);

    useEffect(() => {
        const mergedBreakdown = mergeShopTaxRulesIntoBreakdown(taxesBreakdown, getShopTaxRules(shopTaxesData));

        const result = calculateDocumentTotals({
            mode: isNewTaxVersionActive ? 'multi' : 'legacy',
            serviceListPayload,
            PRICING_TYPES,
            discountId,
            selectedDiscount,
            paymentDetails,
            selectedFees,
            taxesBreakdown: mergedBreakdown,
            documentType: DOCUMENT_TAX_TYPE.INVOICE,
            provinceTaxGroup,
        });

        setPaymentDetails((prev) => ({
            ...prev,
            ...result.paymentDetails,
        }));

        if (isNewTaxVersionActive && shouldSyncCalculatedBreakdown(result.taxesBreakdown)) {
            setTaxesBreakdown((prev) => {
                const next = result.taxesBreakdown;
                return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        serviceListPayload,
        selectedDiscount,
        selectedFees,
        paymentDetails.taxPercentage,
        paymentDetails.discountSource,
        discountId,
        isNewTaxVersionActive,
        shopTaxesData,
        provinceTaxGroup,
        JSON.stringify(taxesBreakdown.map((r) => ({ taxId: r.taxId, applyTax: r.applyTax, invoiceRate: r.invoiceRate }))),
    ]);

    const serviceSubtotalCache = new WeakMap();
    const selectServiceSubtotal = (service) => {
        if (!service) return '0';

        if (serviceSubtotalCache.has(service)) {
            return serviceSubtotalCache.get(service);
        }
        let subtotal = '0';

        // FIXED service pricing
        if (service.pricingType === PRICING_TYPES.FXIED) {
            subtotal = service.fixedPrice || '0';
        }

        // LABOUR & PARTS service pricing
        if (service.pricingType === PRICING_TYPES.LABOUR) {
            const laborAmount = service?.labor?.totalAmount || '0';

            // qty × (cost + per-unit fee): part.totalAmount is qty × cost only, the fee is billed on
            // its own row and must be counted here too (see recordPartGrossAmount).
            const partsAmount = (service.parts || []).reduce((acc, part) => NumericEngine.add(acc, String(recordPartGrossAmount(part))), '0');

            subtotal = NumericEngine.add(laborAmount, partsAmount);
        }

        serviceSubtotalCache.set(service, subtotal);

        return subtotal;
    };

    const handleInvoiceUpdate = async () => {
        try {
            setShowLoader(true);
            if (paymentMethods.length > 0) {
                const filteredPayments = paymentMethods
                    .filter((payment) => payment.amount !== undefined && payment.amount !== null && payment.amount !== '')
                    .map((payment) => {
                        const paymentObj = {
                            transactionType: payment.transactionType,
                            paymentMethod: payment.paymentMethod,
                            amount: payment.amount,
                            paymentReference: payment.paymentReference || '',
                            ...(payment._id ? { _id: payment._id } : {}),
                            ...(payment.paymentDate ? { paymentDate: dayjs(payment.paymentDate).format('YYYY-MM-DD') } : {}),
                        };
                        return paymentObj;
                    });

                const payload = {
                    note: getValues().note || undefined,
                    payments: filteredPayments,
                    shouldSendInvoiceToCarfax: googleReviewDetails.shouldSendInvoiceToCarfax,
                    reviewRequest: {
                        sendGoogleReviewRequest: googleReviewDetails.sendGoogleReviewRequest,
                        customMessage: googleReviewDetails.customMessage || undefined,
                        shouldSendReviewSMSToCustomer: googleReviewDetails.shouldSendReviewSMSToCustomer,
                        shouldSendReviewEmailToCustomer: googleReviewDetails.shouldSendReviewEmailToCustomer,
                        shouldSendReviewNotificationToCustomer: googleReviewDetails.shouldSendReviewNotificationToCustomer,
                    },
                };

                const resp = await dispatch(updateInvoiceRecordPayments(invoiceId, { sendEmail: isSendEmailRef.current }, filterUndefined(payload)));
                if (resp) {
                    if (invoiceData?.appointment?._id) {
                        queryClient.invalidateQueries({
                            queryKey: appointmentKeys.details(invoiceData?.appointment?._id),
                            refetchType: 'all',
                        });
                    }
                    // a pdfWarning means the email was held back because the PDF failed
                    navigate(isSendEmailRef.current && !resp?.pdfWarning ? `/invoice/sent/${resp?._id}` : `/invoice/finalized/${resp?._id}`);
                    setSelectedFees([]);
                    setDiscountId('');
                    setServiceListPayload([]);
                    await fetchApi();
                }
            }
        } catch (error) {
            console.log('🚀 ~ handleInvoiceUpdate ~ error:', error);
        } finally {
            const filteredPayments = paymentMethods.filter((payment) => payment.amount !== undefined && payment.amount !== null && payment.amount !== '');
            setPaymentMethods(filteredPayments);
            setIsRecordModal(false);
            setShowLoader(false);
        }
    };
    const getLinkedEstimateUrl = () => getEstimateDetailUrl(invoiceData?.linkedEstimateId);

    /** Work order detail url by status — the work order it was converted from (spec §6.2). */
    const getLinkedWorkOrderUrl = () => {
        const workOrder = Array.isArray(invoiceData?.linkedWorkOrderId) ? invoiceData?.linkedWorkOrderId?.[0] : invoiceData?.linkedWorkOrderId;
        if (!workOrder?._id) return '#';

        return `/work-orders/${normalizeWorkOrderStatus(workOrder?.status) || WORK_ORDER_STATUS.OPEN}/${workOrder._id}`;
    };

    /** The work order this invoice was created from, if any — the API returns a single object. */
    const sourceWorkOrder = Array.isArray(invoiceData?.linkedWorkOrderId) ? invoiceData?.linkedWorkOrderId?.[0] : invoiceData?.linkedWorkOrderId;

    return (
        <Box>
            <Box
                padding={'32px 24px'}
                sx={{
                    bgcolor: 'background.main',
                    width: 'fit-content',
                    minWidth: '100%',
                }}
            >
                {' '}
                <Grid container sx={{ padding: '16px 0px' }} gap={'8px'}>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div role="presentation" onClick={handleClick}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    to="/invoice/all"
                                    style={{
                                        color: 'black',
                                        opacity: '0.6',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Invoices
                                </Link>
                                <Link
                                    to="/invoice/finalized"
                                    style={{
                                        color: 'black',
                                        opacity: '0.6',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Finalized
                                </Link>
                                <Link to={`/invoice/finalized/${invoiceId}`} style={{ color: 'black', textDecoration: 'none' }}>
                                    {invoiceData?.invoiceNumber}
                                </Link>
                            </Breadcrumbs>
                        </div>
                        {/* Linked documents: the estimate first, the work order beneath it. */}
                        <Stack alignItems="flex-end" spacing={0.5}>
                            {invoiceData?.linkedEstimateId?._id && (
                                <Link to={getLinkedEstimateUrl()} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <LinkIcon color="#002394" />
                                    <Typography
                                        variant="body1"
                                        component="span"
                                        sx={{
                                            color: '#002394',
                                            fontFamily: 'Roboto',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: 400,
                                            lineHeight: '150%',
                                            letterSpacing: '0.15px',
                                            '&:hover': {
                                                textDecoration: 'underline',
                                            },
                                        }}
                                    >
                                        Linked to {invoiceData?.linkedEstimateId?.estimateNumber || ''}
                                    </Typography>
                                </Link>
                            )}

                            {sourceWorkOrder?._id && <LinkedDocumentLink to={getLinkedWorkOrderUrl()} documentNumber={sourceWorkOrder?.workOrderNumber} />}
                        </Stack>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="h4" sx={{ fontWeight: '500' }}>
                            {invoiceData?.invoiceNumber}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} justifyContent="end">
                    <Grid item>
                        <Stack direction={'row'} spacing={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="btn-text-size-manage"
                                startIcon={<VisibilityIcon />}
                                onClick={handlePrintPdf}
                                style={{
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.04px',
                                    fontSize: '14px',
                                    height: '42px',
                                }}
                            >
                                View PDF
                            </Button>

                            <Button
                                variant="contained"
                                startIcon={<SaveAndSendSvg />}
                                size="large"
                                onClick={() => {
                                    if (hasCustomerEmail) {
                                        handleSend();
                                    } else {
                                        setOpenEditCustomer(true);
                                    }
                                }}
                                disabled={invoiceData?.isEmailSent}
                                style={{
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.04px',
                                    fontSize: '14px',
                                    height: '42px',
                                }}
                            >
                                Email to Customer
                            </Button>

                            <Button
                                variant="contained"
                                // color="secondary"
                                color="greyColor"
                                id="demo-positioned-button"
                                aria-controls={open1 ? 'demo-positioned-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open1 ? 'true' : undefined}
                                onClick={handleClick1}
                                size="large"
                                style={{
                                    width: '187px',
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.4px',
                                    fontSize: '14px',
                                    height: '42px',
                                    color: '#000000',
                                    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
                                }}
                            >
                                more actions
                                <ExpandMoreIcon style={{ marginLeft: '8px' }} />
                            </Button>
                            <Menu
                                style={{ top: 3 }}
                                id="demo-positioned-menu"
                                aria-labelledby="demo-positioned-button"
                                anchorEl={anchorEl}
                                open={open1}
                                onClose={handleClose1}
                                sx={{
                                    // MORE ACTIONS menu: the button's width, sitting directly under it.
                                    '& .MuiPaper-root': { width: '187px', minWidth: 'unset!important' },
                                    '& .MuiMenuItem-root': { padding: '6px 12px!important', width: '100%' },
                                }}
                            >
                                {/* <MenuItem onClick={clickDownload}>
                                    <DownloadIcon style={{ marginRight: '8px' }} /> Download PDF
                                </MenuItem> */}
                                <MenuItem
                                    onClick={() => {
                                        navigate(`/invoice/edit/${invoiceId}`);
                                    }}
                                >
                                    <Edit style={{ marginRight: '8px' }} /> Edit Invoice
                                </MenuItem>

                                <MenuItem
                                    onClick={() => {
                                        handleClose1();
                                        setPaymentMethods((prev) => [...prev, newMethod]);
                                        setIsRecordModal(true);
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_12931_158597)">
                                            <path
                                                d="M19.097 12.0085C18.1133 11.6524 17.0212 11.7347 16.1006 12.2342C16.0886 12.2401 12.4961 13.8637 12.4961 13.8637C12.2409 14.0548 11.9449 14.1558 11.6401 14.1558H9.37977C9.099 14.1558 8.87139 13.9285 8.87139 13.648C8.87139 13.3676 9.099 13.1403 9.37977 13.1403H11.6401C12.3466 13.1403 12.3621 11.6866 11.67 11.629L8.51968 11.5928C7.96378 11.5867 7.40741 11.2294 6.82143 11.2159C6.22502 11.2023 5.66079 11.3544 5.15938 11.6796C4.46118 12.1325 3.98451 12.8521 3.66502 13.6067L5.36947 17.9109H10.2704C10.7134 17.9107 11.1488 17.795 11.5334 17.5752L19.1393 13.2241C19.3705 13.0281 19.5491 12.7991 19.4707 12.4475C19.4265 12.2498 19.2846 12.0765 19.097 12.0085ZM0.51062 14.1341L2.83344 20L4.69793 18.9762L2.37506 13.1104L0.51062 14.1341ZM14.5078 0C12.014 0 9.99233 2.04902 9.99233 4.57658C9.99233 7.10415 12.014 9.15316 14.5078 9.15316C17.0016 9.15316 19.0233 7.10415 19.0233 4.57658C19.0233 2.04902 17.0016 0 14.5078 0ZM15.0209 6.86107V7.61974H13.976V6.92278C13.5724 6.86278 13.2136 6.70214 12.9037 6.45863L13.2784 5.40774C13.5823 5.6465 14.0165 5.86466 14.3899 5.86466C14.6762 5.86466 14.8612 5.73325 14.8612 5.52983C14.8612 5.39761 14.8187 5.23919 14.3111 5.03231C13.6757 4.78158 13.0252 4.4138 13.0252 3.59004C13.0252 2.96812 13.4054 2.46846 14.0223 2.27145V1.53338H15.0607V2.20603C15.3766 2.25534 15.7146 2.4094 15.9926 2.58876L15.6031 3.62308C15.3232 3.43637 14.9262 3.25517 14.6076 3.25517C14.2594 3.25517 14.2218 3.43363 14.2218 3.51034C14.2218 3.63047 14.2666 3.73415 14.8464 3.97538C15.4134 4.20799 16.0642 4.58957 16.0642 5.48329C16.0643 6.1218 15.6571 6.65581 15.0209 6.86107Z"
                                                fill="black"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_12931_158597">
                                                <rect width="20" height="20" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span style={{ marginLeft: '8px', width: '103px' }}>Record Payment</span>
                                </MenuItem>

                                <MenuItem
                                    onClick={() => {
                                        navigate(`/customers/${invoiceData?.customer?._id}/${invoiceData?.customer?.createdFrom}`);
                                    }}
                                >
                                    <VisibilityIcon style={{ marginRight: '8px' }} />
                                    View Customer
                                </MenuItem>

                                {invoiceData?.appointment?._id && (
                                    <MenuItem
                                        onClick={() => {
                                            const appointmentId = invoiceData?.appointment?._id;
                                            const appointmentStatus = invoiceData?.appointment?.status;

                                            if (!appointmentId) return;

                                            handleClose1();

                                            if (appointmentStatus === APPOINTMENT_STATUS.CUSTOMER_PAID) {
                                                navigate(`/appointment/past-appointment/${appointmentId}`);
                                            } else {
                                                queryClient.invalidateQueries({
                                                    queryKey: appointmentKeys.details(appointmentId),
                                                });
                                                setAppointmentIdForModal(appointmentId);
                                                setAppointmentModalOpen(true);
                                            }
                                        }}
                                    >
                                        <div style={{ width: '24px', height: '24px', marginRight: '8px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M15.8333 2.50016H12.35C12 1.5335 11.0833 0.833496 10 0.833496C8.91667 0.833496 8 1.5335 7.65 2.50016H4.16667C3.25 2.50016 2.5 3.25016 2.5 4.16683V17.5002C2.5 18.4168 3.25 19.1668 4.16667 19.1668H15.8333C16.75 19.1668 17.5 18.4168 17.5 17.5002V4.16683C17.5 3.25016 16.75 2.50016 15.8333 2.50016ZM10 2.50016C10.4583 2.50016 10.8333 2.87516 10.8333 3.3335C10.8333 3.79183 10.4583 4.16683 10 4.16683C9.54167 4.16683 9.16667 3.79183 9.16667 3.3335C9.16667 2.87516 9.54167 2.50016 10 2.50016ZM15.8333 17.5002H4.16667V4.16683H5.83333V6.66683H14.1667V4.16683H15.8333V17.5002Z"
                                                    fill="black"
                                                />
                                            </svg>
                                        </div>
                                        View Appointment
                                    </MenuItem>
                                )}

                                {/* <MenuItem
                                    onClick={() => {
                                        navigate(`/invoice/new`, {
                                            state: {
                                                duplicateInvoice: invoiceData, // Replace with the actual data
                                            },
                                        });
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M3.33464 18.3333H13.3346C13.7767 18.3333 14.2006 18.1577 14.5131 17.8452C14.8257 17.5326 15.0013 17.1087 15.0013 16.6667V6.66667C15.0013 6.22464 14.8257 5.80072 14.5131 5.48816C14.2006 5.17559 13.7767 5 13.3346 5H3.33464C2.89261 5 2.46868 5.17559 2.15612 5.48816C1.84356 5.80072 1.66797 6.22464 1.66797 6.66667V16.6667C1.66797 17.1087 1.84356 17.5326 2.15612 17.8452C2.46868 18.1577 2.89261 18.3333 3.33464 18.3333ZM5.0013 10.8333H7.5013V8.33333H9.16797V10.8333H11.668V12.5H9.16797V15H7.5013V12.5H5.0013V10.8333Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M16.668 1.66675H6.66797V3.33341H16.668V13.3334H18.3346V3.33341C18.3346 2.41425 17.5871 1.66675 16.668 1.66675Z"
                                            fill="black"
                                        />
                                    </svg>
                                    <span style={{ marginLeft: '8px' }}> Duplicate Invoice</span>
                                </MenuItem> */}

                                {/* <MenuItem onClick={() => {}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M3.06367 10.9106C3.22885 12.1702 3.73378 13.361 4.52431 14.3554C5.31485 15.3498 6.36116 16.1103 7.55103 16.5552C8.7409 17.0002 10.0295 17.1128 11.2785 16.8811C12.5275 16.6494 13.6899 16.082 14.641 15.2399C15.5921 14.3978 16.296 13.3126 16.6773 12.1008C17.0585 10.889 17.1027 9.59633 16.8051 8.36134C16.5075 7.12635 15.8793 5.99567 14.9879 5.09055C14.0965 4.18544 12.9756 3.54005 11.7453 3.22359C8.33475 2.34886 4.80437 4.10443 3.50103 7.37589"
                                            stroke="#D32F2F"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M2.5514 4.03906V7.76476H6.2771"
                                            stroke="#D32F2F"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M12.1667 8.6H13C13 7.4652 11.8521 6.9476 10.9167 6.8284V6H10.0833V6.8284C9.14792 6.9476 8 7.4652 8 8.6C8 9.6824 9.11083 10.2452 10.0833 10.372V12.36C9.48 12.2596 8.83333 11.9504 8.83333 11.4H8C8 12.4356 9.01042 13.0476 10.0833 13.1744V14H10.9167V13.172C11.8521 13.0528 13 12.5348 13 11.4C13 10.2652 11.8521 9.7476 10.9167 9.6284V7.64C11.4708 7.7356 12.1667 8.0164 12.1667 8.6ZM8.83333 8.6C8.83333 8.0164 9.52917 7.7356 10.0833 7.64V9.5596C9.51208 9.4584 8.83333 9.1588 8.83333 8.6ZM12.1667 11.4C12.1667 11.9836 11.4708 12.2644 10.9167 12.36V10.44C11.4708 10.5356 12.1667 10.8164 12.1667 11.4Z"
                                            fill="#D32F2F"
                                        />
                                    </svg>
                                    <span style={{ color: '#D32F2F', marginLeft: '8px' }}> REFUND</span>
                                </MenuItem> */}

                                <MenuItem
                                    onClick={() => {
                                        setIsDeleteModal(true);
                                        handleClose1();
                                    }}
                                >
                                    <Delete style={{ marginRight: '8px', color: '#D32F2F' }} /> <span style={{ color: '#D32F2F' }}> Delete Invoice</span>
                                </MenuItem>
                            </Menu>
                        </Stack>
                    </Grid>
                </Grid>
                <Grid container padding={'32px'} margin={'32px 0'} boxShadow={2} gap={2} sx={{ bgcolor: 'white' }}>
                    <Grid container item spacing={2} justifyContent="space-between" paddingRight={2}>
                        <Grid item lg={8} md={12} sm={12} xs={12}>
                            <Typography variant="h3" fontWeight={400}>
                                Invoice{' '}
                            </Typography>
                            <InvoiceStatusChips invoiceData={invoiceData} showGoogleReviewChip={invoiceData?.reviewRequest?.reviewCompleted} />
                        </Grid>
                        <Grid item>
                            <Stack spacing={0}>
                                <Typography variant="body1" fontWeight={'500'} fontSize={'24px'} lineHeight={'133.33%'}>
                                    {invoiceData?.invoiceNumber}
                                </Typography>
                                {invoiceData?.serviceAdvisor?.name && (
                                    <Typography variant="body1" fontWeight={400} lineHeight={'150%'} mt={1}>
                                        Service Advisor: {invoiceData?.serviceAdvisor?.name}
                                    </Typography>
                                )}

                                {invoiceData?.serviceTechnician?.name && (
                                    <Typography variant="body1" fontWeight={400} lineHeight={'150%'} mt={0.5}>
                                        Technician: {invoiceData?.serviceTechnician?.name}
                                    </Typography>
                                )}
                            </Stack>
                        </Grid>
                    </Grid>

                    <Divider style={{ width: '100%' }} />

                    <Grid container item justifyItems={'space-between'}>
                        <DetailPageHeaderInfoColumns
                            invoiceDate={invoiceData?.invoiceDate}
                            customer={invoiceData?.customer}
                            customerPO={invoiceData?.customerPO}
                            vehicle={invoiceData?.vehicle}
                            mileageUnit={mileageUnit}
                            odoDroppedOff={invoiceData?.odoDroppedOff}
                            odoReturned={invoiceData?.odoReturned}
                            mileageInDate={invoiceData?.appointmentDroppedOffDate}
                            mileageOutDate={invoiceData?.appointmentCompletionDate}
                        />

                        {invoiceData?.note && (
                            <Grid item xs={12} mt={2}>
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.87)',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        lineHeight: '150%',
                                        letterSpacing: '0.15px',
                                    }}
                                >
                                    Internal Shop Memo
                                </Typography>
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.65)',
                                        marginTop: '8px',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '24px',
                                        letterSpacing: '0.15px',
                                    }}
                                >
                                    {invoiceData?.note}
                                </Typography>
                            </Grid>
                        )}

                        {invoiceData &&
                            invoiceData?.services?.length > 0 &&
                            invoiceData?.services?.map((item, index) => {
                                console.log('🚀 ~ InvoiceFinalized ~ item:', item);
                                const serviceSubtotal = selectServiceSubtotal(item) ?? '0';

                                return (
                                    <>
                                        <Grid
                                            container
                                            item
                                            /*style={{
                                                            backgroundColor: "#c5d0da",
                                                            color: "black",
                                                            marginTop: "20px",
                                                          }}*/
                                            sx={{
                                                bgcolor: 'secondary.main',
                                                color: 'white',
                                                mt: '32px',
                                                borderTopLeftRadius: '4px',
                                                borderTopRightRadius: '4px',
                                            }}
                                        >
                                            <Grid item xs={12}>
                                                <Typography
                                                    sx={{
                                                        p: '16px',
                                                        fontSize: '20px',
                                                        fontWeight: 500,
                                                        lineHeight: '32px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    {item?.serviceName || item?.serviceId?.name}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        {/* Service Table */}

                                        <Grid container item>
                                            <Grid item xl={12} md={12} sm={12} xs={12}>
                                                <TableContainer sx={{ maxHeight: 600 }}>
                                                    <Table
                                                        aria-label="service table"
                                                        padding="16px"
                                                        sx={{
                                                            width: '100%',
                                                            tableLayout: 'fixed',
                                                            '& .MuiTableCell-root': {
                                                                borderBottom: '1px solid rgba(0,0,0,0.12)',
                                                                verticalAlign: 'middle',
                                                                color: '#212121',
                                                            },
                                                        }}
                                                    >
                                                        <colgroup>
                                                            <col style={{ width: 56 }} />
                                                            <col />
                                                            <col style={{ width: 96 }} />
                                                            <col style={{ width: 90 }} />
                                                            <col style={{ width: 100 }} />
                                                            {showLineTax && <col style={{ width: 52 }} />}
                                                        </colgroup>

                                                        {/* Table Head */}
                                                        <TableHead
                                                            sx={{
                                                                backgroundColor: '#F8F8F8',
                                                                height: '40px',
                                                                borderBottom: 'none',
                                                            }}
                                                        >
                                                            <TableRow
                                                                sx={{
                                                                    height: '40px',
                                                                    borderBottom: 'none',
                                                                    '& > th, & > td': {
                                                                        px: '12px',
                                                                    },
                                                                }}
                                                            >
                                                                {/* No */}
                                                                <TableCell
                                                                    sx={{
                                                                        width: '56px',
                                                                        fontSize: '14px',
                                                                        borderBottom: 'none',
                                                                    }}
                                                                    style={{
                                                                        paddingTop: '0',
                                                                        paddingBottom: '0',
                                                                        paddingLeft: '16px',
                                                                        paddingRight: '0',
                                                                    }}
                                                                >
                                                                    No.
                                                                </TableCell>

                                                                {/* Description */}
                                                                <TableCell
                                                                    sx={{
                                                                        fontSize: '14px',
                                                                        paddingTop: '0',
                                                                        paddingBottom: '0',
                                                                        borderBottom: 'none',
                                                                    }}
                                                                    style={{
                                                                        height: '40px',
                                                                        paddingLeft: '0',
                                                                        paddingRight: '10px',
                                                                    }}
                                                                >
                                                                    Description
                                                                </TableCell>

                                                                {/* Quantity */}
                                                                <TableCell
                                                                    // align="left"
                                                                    sx={{
                                                                        width: '96px',
                                                                        fontSize: '14px',
                                                                        borderBottom: 'none',
                                                                    }}
                                                                    style={{ padding: '0 10px' }}
                                                                >
                                                                    Quantity
                                                                </TableCell>

                                                                {/* Price */}
                                                                <TableCell
                                                                    // align="center"
                                                                    sx={{
                                                                        width: '90px',
                                                                        fontSize: '14px',
                                                                        borderBottom: 'none',
                                                                    }}
                                                                    style={{ padding: '0 10px' }}
                                                                >
                                                                    Price
                                                                </TableCell>

                                                                {/* Amount */}
                                                                <TableCell
                                                                    align={showLineTax ? 'left' : 'right'}
                                                                    sx={{
                                                                        width: '100px',
                                                                        fontSize: '14px',
                                                                        borderBottom: 'none',
                                                                    }}
                                                                    style={{ padding: '0 10px' }}
                                                                >
                                                                    Amount
                                                                </TableCell>

                                                                {/* Tax */}
                                                                {showLineTax && (
                                                                    <TableCell
                                                                        align="center"
                                                                        sx={{
                                                                            width: '52px',
                                                                            fontSize: '14px',
                                                                            paddingTop: '0',
                                                                            paddingBottom: '0',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{ paddingRight: '16px', paddingLeft: '10px' }}
                                                                    >
                                                                        Tax
                                                                    </TableCell>
                                                                )}
                                                            </TableRow>
                                                        </TableHead>

                                                        {/* Table Body */}
                                                        <TableBody>
                                                            {/* Labour Description */}
                                                            {item?.description?.trim() && item?.pricingType === PRICING_TYPES.LABOUR && (
                                                                <TableRow>
                                                                    <TableCell
                                                                        style={{
                                                                            padding: '6px 0 6px 16px',
                                                                        }}
                                                                    />

                                                                    <TableCell
                                                                        style={{
                                                                            padding: '6px 10px 6px 0',
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                                lineHeight: '143%',
                                                                            }}
                                                                        >
                                                                            {item?.description}
                                                                        </Typography>
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: '6px 10px' }} />
                                                                    <TableCell style={{ padding: '6px 10px' }} />
                                                                    <TableCell style={{ padding: '6px 10px' }} />
                                                                    {showLineTax && <TableCell style={{ padding: '6px 16px 6px 10px' }} />}
                                                                </TableRow>
                                                            )}

                                                            {/* Labour Row */}
                                                            {item?.pricingType === PRICING_TYPES.LABOUR && item?.labor && item?.labor?.qty > 0 ? (
                                                                <TableRow key={item?.labor?.qty}>
                                                                    <TableCell
                                                                        style={{
                                                                            fontSize: '16px',
                                                                            padding: '6px 0 6px 16px',
                                                                        }}
                                                                    >
                                                                        1
                                                                    </TableCell>

                                                                    <TableCell
                                                                        style={{
                                                                            padding: '6px 10px 6px 0',
                                                                            fontSize: '16px',
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                                lineHeight: '143%',
                                                                            }}
                                                                        >
                                                                            Labour
                                                                        </Typography>
                                                                    </TableCell>

                                                                    <TableCell
                                                                        style={{
                                                                            padding: '6px 10px',
                                                                            fontSize: '16px',
                                                                        }}
                                                                    >
                                                                        {item?.labor?.qty}
                                                                    </TableCell>

                                                                    <TableCell
                                                                        style={{
                                                                            padding: '6px 10px',
                                                                            fontSize: '16px',
                                                                        }}
                                                                    >
                                                                        {item?.labor?.ratePerHour
                                                                            ? NumericEngine.format(item?.labor?.ratePerHour || 0, {
                                                                                  formatCurrency: true,
                                                                                  trailingZeros: true,
                                                                              })
                                                                            : '$0.00'}
                                                                    </TableCell>

                                                                    {/* Amount */}
                                                                    <TableCell
                                                                        align={showLineTax ? 'left' : 'right'}
                                                                        style={{
                                                                            padding: '6px 10px',
                                                                            fontSize: '16px',
                                                                            fontWeight: 400,
                                                                        }}
                                                                    >
                                                                        <Typography fontWeight={400} fontSize={16}>
                                                                            {item?.labor?.totalAmount
                                                                                ? NumericEngine.format(item?.labor?.totalAmount || 0, {
                                                                                      formatCurrency: true,
                                                                                      trailingZeros: true,
                                                                                  })
                                                                                : '$0.00'}
                                                                        </Typography>
                                                                    </TableCell>

                                                                    {/* Tax */}
                                                                    {showLineTax && (
                                                                        <TableCell
                                                                            align="center"
                                                                            style={{
                                                                                padding: '6px 16px 6px 10px',
                                                                                fontSize: '16px',
                                                                            }}
                                                                        >
                                                                            <LineTaxCell
                                                                                taxesBreakdown={item?.labor?.taxesBreakdown}
                                                                                lineAmount={item?.labor?.totalAmount}
                                                                                documentType={DOCUMENT_TAX_TYPE.INVOICE}
                                                                                shopTaxesData={shopTaxesData}
                                                                                provinceTaxGroup={provinceTaxGroup}
                                                                                documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                kind={LINE_TAX_KIND.LABOUR}
                                                                                editable={false}
                                                                                discount={invoiceData?.discount}
                                                                                subTotal={invoiceData?.subTotal}
                                                                            />
                                                                        </TableCell>
                                                                    )}
                                                                </TableRow>
                                                            ) : item?.pricingType === PRICING_TYPES.FXIED ? (
                                                                /* Fixed Price Row */
                                                                <TableRow key={item?.labor?.qty}>
                                                                    <TableCell
                                                                        style={{
                                                                            fontSize: '16px',
                                                                            padding: '6px 0 6px 16px',
                                                                        }}
                                                                    >
                                                                        1
                                                                    </TableCell>

                                                                    <TableCell
                                                                        style={{
                                                                            padding: '6px 10px 6px 0',
                                                                            fontSize: '16px',
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                                lineHeight: '143%',
                                                                            }}
                                                                        >
                                                                            {item?.pricingType === PRICING_TYPES.FXIED && item?.description
                                                                                ? item?.description
                                                                                : item?.pricingType === PRICING_TYPES.FXIED
                                                                                  ? 'Fixed Price'
                                                                                  : item?.serviceName || item?.serviceId?.name}
                                                                        </Typography>
                                                                    </TableCell>

                                                                    <TableCell style={{ padding: '6px 10px' }} />

                                                                    <TableCell style={{ padding: '6px 10px' }} />

                                                                    {/* Amount */}
                                                                    <TableCell
                                                                        align={showLineTax ? 'left' : 'right'}
                                                                        style={{
                                                                            padding: '6px 10px',
                                                                            fontSize: '16px',
                                                                        }}
                                                                    >
                                                                        <Typography fontWeight={400} fontSize={16}>
                                                                            {item?.fixedPrice
                                                                                ? NumericEngine.format(item?.fixedPrice || 0, {
                                                                                      formatCurrency: true,
                                                                                      trailingZeros: true,
                                                                                  })
                                                                                : '$0.00'}
                                                                        </Typography>
                                                                    </TableCell>

                                                                    {/* Tax */}
                                                                    {showLineTax && (
                                                                        <TableCell
                                                                            align="center"
                                                                            style={{
                                                                                padding: '6px 16px 6px 10px',
                                                                                fontSize: '16px',
                                                                            }}
                                                                        >
                                                                            <LineTaxCell
                                                                                taxesBreakdown={item?.taxesBreakdown}
                                                                                lineAmount={item?.fixedPrice}
                                                                                documentType={DOCUMENT_TAX_TYPE.INVOICE}
                                                                                shopTaxesData={shopTaxesData}
                                                                                provinceTaxGroup={provinceTaxGroup}
                                                                                documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                kind={LINE_TAX_KIND.PACKAGE}
                                                                                editable={false}
                                                                                discount={invoiceData?.discount}
                                                                                subTotal={invoiceData?.subTotal}
                                                                            />
                                                                        </TableCell>
                                                                    )}
                                                                </TableRow>
                                                            ) : null}

                                                            {item?.parts &&
                                                                item?.parts?.length > 0 &&
                                                                item?.parts?.map((row, index) => {
                                                                    const showFeeCell = row?.fee?.name && row.feeAmount > 0;
                                                                    return (
                                                                        <Fragment key={index}>
                                                                            <TableRow>
                                                                                {/* No */}
                                                                                <TableCell
                                                                                    style={{
                                                                                        padding: '6px 0 6px 16px',
                                                                                        fontSize: '16px',
                                                                                        borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                    }}
                                                                                >
                                                                                    {index + (item?.fixedPrice > 0 || item?.labor?.qty > 0 ? 2 : 1)}
                                                                                </TableCell>

                                                                                {/* Description (name + inline supplier/brand details) */}
                                                                                <TableCell
                                                                                    style={{
                                                                                        padding: '6px 12px 6px 0',
                                                                                        borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                    }}
                                                                                >
                                                                                    <Box>
                                                                                        <Typography
                                                                                            sx={{
                                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                                fontSize: '16px',
                                                                                                fontWeight: 400,
                                                                                                letterSpacing: '0.17px',
                                                                                                lineHeight: '143%',
                                                                                                textDecoration:
                                                                                                    row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED
                                                                                                        ? 'none'
                                                                                                        : 'underline',
                                                                                                cursor:
                                                                                                    row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED
                                                                                                        ? 'default'
                                                                                                        : 'pointer',
                                                                                            }}
                                                                                            onClick={() => {
                                                                                                if (row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED) {
                                                                                                    return;
                                                                                                }
                                                                                                setSelectedInventoryId(row?.inventoryId || row?.inventory?._id);
                                                                                                setInventoryOption(row);
                                                                                                if (row?.inventoryBatches?.length > 1) {
                                                                                                    setBatchSelectionModal(true);
                                                                                                } else if (
                                                                                                    row?.inventoryBatches?.length > 0 &&
                                                                                                    row?.inventoryBatches[0]?.batchNumber
                                                                                                ) {
                                                                                                    setBatchNumber(
                                                                                                        row?.inventoryBatches[0]?.batchNumber ||
                                                                                                            row.batchNumber[0]
                                                                                                    );
                                                                                                    setOpenpartModel(true);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            {row?.partName || row?.inventory?.part?.partName}
                                                                                        </Typography>

                                                                                        <Stack
                                                                                            direction="row"
                                                                                            // alignItems="center"
                                                                                            spacing={1.25}
                                                                                            sx={{}}
                                                                                            divider={
                                                                                                <Box
                                                                                                    sx={{
                                                                                                        width: '1px',
                                                                                                        height: '16px',
                                                                                                        bgcolor: 'rgba(0, 0, 0, 0.12)',
                                                                                                    }}
                                                                                                />
                                                                                            }
                                                                                        >
                                                                                            {(row?.partNumber || row?.tyreDimension) && (
                                                                                                <Stack
                                                                                                    direction="row"
                                                                                                    alignItems="center"
                                                                                                    spacing={0.5}
                                                                                                    mt={'4px'}
                                                                                                >
                                                                                                    <Typography
                                                                                                        component="span"
                                                                                                        sx={{
                                                                                                            fontSize: '16px',
                                                                                                            fontWeight: 400,
                                                                                                            letterSpacing: '0.17px',
                                                                                                            color: '#006CDD',
                                                                                                        }}
                                                                                                    >
                                                                                                        #
                                                                                                    </Typography>
                                                                                                    <Typography
                                                                                                        component="span"
                                                                                                        sx={{
                                                                                                            fontSize: '16px',
                                                                                                            fontWeight: 400,
                                                                                                            letterSpacing: '0.17px',
                                                                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                                                                        }}
                                                                                                    >
                                                                                                        {row?.part?.partsType === PART_TYPES.PARTS
                                                                                                            ? row?.partNumber
                                                                                                            : row?.tyreDimension}
                                                                                                    </Typography>
                                                                                                </Stack>
                                                                                            )}

                                                                                            {row?.supplier?.name && (
                                                                                                <Stack direction="row" alignItems="center" spacing={0.75}>
                                                                                                    <PartBrandSvg />
                                                                                                    <Typography
                                                                                                        sx={{
                                                                                                            fontSize: '16px',
                                                                                                            fontWeight: 400,
                                                                                                            letterSpacing: '0.17px',
                                                                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                                                                        }}
                                                                                                    >
                                                                                                        {row.supplier.name}
                                                                                                    </Typography>
                                                                                                </Stack>
                                                                                            )}

                                                                                            {row?.partsBrand?.name && (
                                                                                                <Stack direction="row" alignItems="center" spacing={0.75}>
                                                                                                    <PartCategorySvg />
                                                                                                    <Typography
                                                                                                        sx={{
                                                                                                            fontSize: '16px',
                                                                                                            fontWeight: 400,
                                                                                                            letterSpacing: '0.17px',
                                                                                                            color: 'rgba(0, 0, 0, 0.87)',
                                                                                                        }}
                                                                                                    >
                                                                                                        {row.partsBrand.name}
                                                                                                    </Typography>
                                                                                                </Stack>
                                                                                            )}
                                                                                        </Stack>
                                                                                    </Box>
                                                                                </TableCell>

                                                                                {/* Quantity */}
                                                                                <TableCell
                                                                                    // align="left"
                                                                                    style={{
                                                                                        padding: '6px 10px',
                                                                                        fontSize: '16px',
                                                                                        borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                    }}
                                                                                >
                                                                                    {row?.totalQty}
                                                                                </TableCell>

                                                                                {/* Price */}
                                                                                <TableCell
                                                                                    style={{
                                                                                        padding: '6px 10px',
                                                                                        fontSize: '16px',
                                                                                        borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                    }}
                                                                                >
                                                                                    {row?.cost
                                                                                        ? NumericEngine.format(row?.cost || 0, {
                                                                                              formatCurrency: true,
                                                                                              trailingZeros: true,
                                                                                          })
                                                                                        : '$0.00'}
                                                                                </TableCell>

                                                                                {/* Amount */}
                                                                                <TableCell
                                                                                    align={showLineTax ? 'left' : 'right'}
                                                                                    style={{
                                                                                        padding: '6px 10px',
                                                                                        fontSize: '16px',
                                                                                        fontWeight: 400,
                                                                                        borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                    }}
                                                                                >
                                                                                    <Typography fontWeight={400} fontSize={16}>
                                                                                        {row?.totalAmount
                                                                                            ? NumericEngine.format(row?.totalAmount || 0, {
                                                                                                  formatCurrency: true,
                                                                                                  trailingZeros: true,
                                                                                              })
                                                                                            : '$0.00'}
                                                                                    </Typography>
                                                                                </TableCell>

                                                                                {/* Tax */}
                                                                                {showLineTax && (
                                                                                    <TableCell
                                                                                        align="center"
                                                                                        style={{
                                                                                            padding: '6px 16px 6px 10px',
                                                                                            fontSize: '16px',
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        <LineTaxCell
                                                                                            taxesBreakdown={row?.taxesBreakdown}
                                                                                            // Tax base = qty × (cost + fee); totalAmount omits the fee.
                                                                                            lineAmount={recordPartGrossAmount(row)}
                                                                                            documentType={DOCUMENT_TAX_TYPE.INVOICE}
                                                                                            shopTaxesData={shopTaxesData}
                                                                                            provinceTaxGroup={provinceTaxGroup}
                                                                                            documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                            kind={LINE_TAX_KIND.PARTS}
                                                                                            editable={false}
                                                                                            discount={invoiceData?.discount}
                                                                                            subTotal={invoiceData?.subTotal}
                                                                                        />
                                                                                    </TableCell>
                                                                                )}
                                                                            </TableRow>

                                                                            {/* Description Row */}
                                                                            {row?.lastDescription && (
                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        style={{
                                                                                            paddingTop: 0,
                                                                                            borderBottom: showFeeCell ? 'none' : undefined,
                                                                                        }}
                                                                                    />

                                                                                    <TableCell
                                                                                        colSpan={4}
                                                                                        style={{
                                                                                            padding: '0 12px 6px 0',
                                                                                            borderBottom: showFeeCell ? 'none' : undefined,
                                                                                        }}
                                                                                    >
                                                                                        <Typography
                                                                                            sx={{
                                                                                                fontSize: '14px',
                                                                                                fontWeight: 400,
                                                                                                lineHeight: '20px',
                                                                                                letterSpacing: '0.4px',
                                                                                                color: '#848484',
                                                                                            }}
                                                                                        >
                                                                                            {row?.lastDescription}
                                                                                        </Typography>
                                                                                    </TableCell>

                                                                                    {showLineTax && (
                                                                                        <TableCell
                                                                                            style={{
                                                                                                paddingTop: 0,
                                                                                                borderBottom: showFeeCell ? 'none' : undefined,
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                </TableRow>
                                                                            )}

                                                                            {showFeeCell && (
                                                                                <TableRow>
                                                                                    <TableCell style={{ padding: '0 12px 6px 16px', fontSize: '16px' }} />
                                                                                    <TableCell style={{ padding: '0 12px 6px 0', fontSize: '16px' }}>
                                                                                        {row?.fee?.name}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ padding: '0 12px', fontSize: '16px' }}>
                                                                                        {row?.totalQty}
                                                                                    </TableCell>
                                                                                    <TableCell style={{ padding: '0 12px', fontSize: '16px' }}>
                                                                                        {NumericEngine.format(row?.feeAmount || 0, {
                                                                                            formatCurrency: true,
                                                                                            trailingZeros: true,
                                                                                        })}
                                                                                    </TableCell>

                                                                                    <TableCell
                                                                                        align={showLineTax ? 'left' : 'right'}
                                                                                        style={{ padding: '0 12px', fontSize: '16px' }}
                                                                                    >
                                                                                        {NumericEngine.format(
                                                                                            NumericEngine.multiply(row?.totalQty || 0, row?.feeAmount || 0),
                                                                                            { formatCurrency: true, trailingZeros: true }
                                                                                        )}
                                                                                    </TableCell>

                                                                                    {showLineTax && (
                                                                                        <TableCell style={{ padding: '0 16px 0 10px', fontSize: '16px' }} />
                                                                                    )}
                                                                                </TableRow>
                                                                            )}
                                                                        </Fragment>
                                                                    );
                                                                })}

                                                            {shouldShowPerServiceSubtotalRow(item, { variant: 'invoice-detail' }) && (
                                                                <TableRow>
                                                                    <TableCell
                                                                        colSpan={4}
                                                                        style={{
                                                                            // borderBottom: 0,
                                                                            background: '#fff',
                                                                            padding: '12px',
                                                                        }}
                                                                    />

                                                                    <TableCell
                                                                        align={showLineTax ? 'left' : 'right'}
                                                                        style={{
                                                                            // borderBottom: 0,
                                                                            background: '#fff',
                                                                            padding: '6px 12px',
                                                                            fontSize: '16px',
                                                                            fontWeight: 400,
                                                                        }}
                                                                    >
                                                                        <Typography fontWeight={400} fontSize={16}>
                                                                            {serviceSubtotal > 0
                                                                                ? NumericEngine.format(serviceSubtotal, {
                                                                                      formatCurrency: true,
                                                                                      trailingZeros: true,
                                                                                  })
                                                                                : '$0.00'}
                                                                        </Typography>
                                                                    </TableCell>

                                                                    {showLineTax && (
                                                                        <TableCell
                                                                            style={{
                                                                                // borderBottom: 0,
                                                                                background: '#fff',
                                                                                padding: '6px 12px',
                                                                            }}
                                                                        />
                                                                    )}
                                                                </TableRow>
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                        </Grid>
                                    </>
                                );
                            })}

                        {/* Fees Table  */}
                        {invoiceData?.fees?.length > 0 && <InvoiceFeesTable invoiceData={invoiceData} />}

                        {invoiceData?.recommendationNotes && <InvoiceRecommandationSection invoiceData={invoiceData} />}

                        {/* Shop Supplies Table  */}
                        {invoiceData &&
                            invoiceData?.shopSupplies?.length > 0 &&
                            invoiceData?.shopSupplies?.map((item, index) => {
                                return <ShopSuppliesTable item={item} index={index} invoiceData={invoiceData} />;
                            })}
                        <Grid container spacing={2} mt={'32px'} justifyContent={'space-between'} alignItems={'flex-start'}>
                            <Grid item xs={12} md={6} lg={6} xl={7}>
                                {invoiceData?.termsAndWarranty?.title && invoiceData?.termsAndWarranty?.description && (
                                    <InvoiceTermsWarranty data={invoiceData} />
                                )}
                            </Grid>
                            <Grid item xs={12} md={6} lg={6} xl={5}>
                                {/* Payment Details Table  */}

                                <InvoicePaymenetDetails invoiceData={invoiceData} paymentDetails={paymentDetails} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            {openEditCustomer && (
                <Suspense fallback={<CircularProgress />}>
                    <AddCustomerModalV4
                        from="invoice_email"
                        openModal={openEditCustomer}
                        customerId={invoiceData?.customer?.refIdImport || invoiceData?.customer?.refIdUsers || customerId}
                        customerType={invoiceData?.customer?.createdFrom || invoiceData?.customer?.source || SHOP_CREATED}
                        onClose={() => {
                            setOpenEditCustomer(false);
                        }}
                        onSubmitModal={(updatedCustomer) => {
                            setOpenEditCustomer(false);

                            // update local customer state if needed
                            if (updatedCustomer) {
                                setCustomerData?.(updatedCustomer);
                            }

                            // continue send flow
                            handleSend();
                        }}
                    />
                </Suspense>
            )}

            <CommonDialog
                loader={deleteLoader}
                open={isDeleteModal}
                onClose={() => {
                    setIsDeleteModal(false);
                }}
                onSave={async () => {
                    setDeleteLoader(true);
                    const resp = await deleteFinalizedInvoice(invoiceId);
                    if (resp) {
                        queryClient.invalidateQueries({ queryKey: businessInvoicesKeys.all, refetchType: 'all' });
                        queryClient.invalidateQueries({ queryKey: [...reviewRequestKeys.all, 'quickReviewUsers'], refetchType: 'all' });
                        navigate('/invoice/all');
                    }
                    setIsDeleteModal(false);
                    setDeleteLoader(true);
                }}
                dialogTitle={'Delete Invoice?'}
                dialogSubtitle={`Are you sure you want to delete Invoice ${invoiceData?.invoiceNumber || ''}? This action cannot be undone.`}
            />

            <AppointmentModel
                open={appointmentModalOpen}
                handleClose={handleCloseAppointmentModal}
                data={appointmentDetailData?.data}
                status={appointmentDetailData?.data?.status}
                fetchAppointmentDetails={refreshAppointmentDetails}
                recallDetailsAPI={refreshAppointmentDetails}
                columns={appointmentModalColumns}
                setAppointmentDropOffODo={() => {}}
                setAppointmentCompletionOffODo={() => {}}
                setUpdateStatus={() => {}}
                setSelectId={() => {}}
                fetchCalendarDataonAppointmentStatusChange={() => {}}
                show={false}
                handleStatusClose={() => {}}
                handleStatus={() => {}}
                fromCaledner={false}
            />

            <RecordPaymentDialog
                allowCarfax={shopConfigData?.config?.carfaxSettings?.dailyROUploadEnabled || false}
                showInvoiceSentChip={invoiceData?._id && invoiceData?.reviewRequest?.reviewCompleted}
                shopConfigData={shopConfigData}
                open={isRecordModal}
                googleReviewDetails={googleReviewDetails}
                setGoogleReviewDetails={setGoogleReviewDetails}
                appointmentData={appointmentData}
                appointmentIdFromUrl={invoiceData?.appointment?._id}
                googleReviewMessage={googleReviewMessage}
                shopName={SHOP_NAME}
                invoiceData={invoiceData}
                paymentMethods={paymentMethods}
                setPaymentMethods={setPaymentMethods}
                setIsRecordModal={setIsRecordModal}
                isCarfaxPublished={invoiceData?.isCarfaxInvoiceSent || false}
                onClose={() => {
                    const filteredPayments = paymentMethods.filter(
                        (payment) => payment.amount !== undefined && payment.amount !== null && payment.amount !== ''
                    );
                    setPaymentMethods(filteredPayments);
                    setIsRecordModal(false);
                    resetField('note', {
                        defaultValue: invoiceData?.note || '',
                    });
                }}
                saveEmailFn={() => {
                    if (hasCustomerEmail) {
                        isSendEmailRef.current = true;
                        handleInvoiceUpdate();
                    } else {
                        isSendEmailRef.current = true;
                        setOpenEditCustomer(true);
                    }
                }}
                saveFn={() => {
                    isSendEmailRef.current = false;
                    handleInvoiceUpdate();
                }}
                control={control}
                errors={errors}
                paymentDetails={paymentDetails}
                setPaymentDetails={setPaymentDetails}
                isNewTaxVersion={isNewTaxVersionActive || isNewTaxVersion(invoiceData)}
                taxesBreakdown={taxesBreakdown}
                setTaxesBreakdown={setTaxesBreakdown}
                documentType={DOCUMENT_TAX_TYPE.INVOICE}
            />
            <AddInventoryModal
                type={INVENTORY_TYPES.INVOICE}
                showUsedInInvoiceFeild={true}
                FeildLabelName="Used in Invoice"
                isUsedInvoiceQty={inventoryOption?.totalQty}
                isUseLastCost={inventoryOption?.totalQty ? true : false}
                inventoryId={selectedInventoryId}
                batchNumber={batchNumber}
                viewOnly={true}
                openModal={openPartModel}
                closeModal={() => {
                    setOpenpartModel(false);
                    setInventoryOption(null);
                    setSelectedInventoryId(null);
                    setBatchNumber(null);
                }}
                onSubmitModal={() => {
                    setOpenpartModel(false);
                    setSelectedInventoryId(null);
                    setInventoryOption(null);
                    setBatchNumber(null);
                }}
                showLoader={false}
                setShowLoader={() => {}}
                selectedInventory={[]}
                setSelectedInventory={() => {}}
                fetchApi={(data) => {}}
                ShowAllTabs={false}
                ShowTabIndex={0}
                modalType={'edit'}
            />

            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
            <Dialog open={showLoader || (appointmentModalOpen && isDetailLoading)}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default InvoiceFinalized;
